<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.date') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.transactionDateTime }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.sum') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.transactionAmount }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.operation-type') }}
        </div>
        <div class="transaction-item-info__value">
          {{ $t(`transaction-types.${transaction.transactionType}`) }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.commission') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.transactionCommission }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{
            $t('operation-information.transaction-info.partner-transaction-id')
          }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.partnerTransactionId }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.currency') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.transactionCurrencyPlain }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.xpay-operation-id') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.operationId }}
        </div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.status') }}
        </div>
        <div class="transaction-item-info__value">
          <transaction-status
            :status-id="transaction.operationStatus"
            mode="plain"
          ></transaction-status>
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{
            $t(
              'operation-information.transaction-info.point-transaction-initiation'
            )
          }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div
        class="transaction-item-info__group"
        v-if="transaction.error.msg.length > 0"
      >
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.error-description') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.error.msg }}
        </div>
      </div>
    </div>
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.terminal-id') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.terminalId }}
        </div>
      </div>
      <div
        class="transaction-item-info__group"
        v-if="transaction.error.code.length > 0"
      >
        <div class="transaction-item-info__title">
          {{ $t('operation-information.transaction-info.error-code') }}
        </div>
        <div class="transaction-item-info__value">
          {{ transaction.error.code }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TransactionStatus from '@vue-app/components/transaction/TransactionStatus.vue'
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemTransactionInfo',
  components: { TransactionStatus },
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
